import React from 'react';
import AdminDashboardLayout from '../Common/AdminDashboardLayout/AdminDashboardLayout';
import ManageVisits from './ManageVisits';

const ManageVisitsWrapper = () => {
  return (
    // <AdminDashboardLayout>
      <ManageVisits />
    // </AdminDashboardLayout>
  );
};

export default ManageVisitsWrapper;
